export interface SkippedOption {
  value: 'skipped';
  label: string;
}

export interface AnswerOption {
  value: string;
  score: number;
  label: string;
}

export type SurveyOption = SkippedOption | AnswerOption;

export const SURVEY_OPTIONS: Record<string, SurveyOption> = {
  skipped: { value: 'skipped', label: 'Overslaan' },
  not_helpful: { value: 'not_helpful', score: 1, label: 'Niet geholpen' },
  slightly_helpful: {
    value: 'slightly_helpful',
    score: 2,
    label: 'Een beetje geholpen',
  },
  helpful: { value: 'helpful', score: 3, label: 'Goed geholpen' },
};

// Array of answerable options (excluding skipped) for rendering in template
export const SURVEY_ANSWER_OPTIONS: AnswerOption[] = [
  SURVEY_OPTIONS['not_helpful'] as AnswerOption,
  SURVEY_OPTIONS['slightly_helpful'] as AnswerOption,
  SURVEY_OPTIONS['helpful'] as AnswerOption,
];
